<div class="signup-container">
  <div class="signup-left"></div>
  <div class="signup-right">
    <div>
      <mat-stepper [linear]="isLinear" #stepper>
        <mat-step [stepControl]="firstForm">
          <!-- <ng-template matStepLabel>Step 1</ng-template> -->
          <form [formGroup]="firstForm" subscriptSizing="dynamic">
            <div class="header-form step-one">
              <p>
                <button type="button" class="back-button" i18n (click)="handleGotoLogin()">
                  <app-icons
                    [ariaHidden]="ariaHidden"
                    [ariaLabel]="ariaLabel"
                    [icon]="icon"
                    class="back-chevron"
                  ></app-icons>
                  {{ backLabel }}
                </button>
              </p>
              <div class="steps">
                <p i18n>Step 1 of 3</p>
                <span i18n>Signup</span>
              </div>
            </div>
            <div class="heading">
              <h6 i18n>Register your account</h6>
              <p i18n>Fill in the details below to register your account.</p>
            </div>
            <div class="name">
              <div class="fname">
                <app-input
                  [formCntlName]="fname"
                  [inputType]="textInputType"
                  [label]="fnameLabel"
                  [placeholder]="fnamePlaceHolder"
                  (keyup)="handleChange()"
                ></app-input>
                @if (fname.hasError('required') && fname.touched) {
                  <mat-error i18n>First Name is required</mat-error>
                }
                @if (fname.hasError('containsNumber')) {
                  <mat-error i18n>First Name should not contain numbers.</mat-error>
                }
                @if (fname.hasError('containsSpecialChars')) {
                  <mat-error i18n>Special characters are not allowed in First Name.</mat-error>
                }
                @if (fname.hasError('textOnly')) {
                  <mat-error i18n>Text must have no extra spaces and only letters.</mat-error>
                }
                @if (fname.hasError('maxlength')) {
                  <mat-error i18n>First name cannot be longer than 256 characters </mat-error>
                }
              </div>
              <div class="lname">
                <app-input
                  [formCntlName]="lname"
                  [inputType]="textInputType"
                  [label]="lnameLabel"
                  [placeholder]="lnamePlaceHolder"
                  (keyup)="handleChange()"
                ></app-input>
                @if (lname.hasError('required') && lname.touched) {
                  <mat-error i18n>Last Name is required</mat-error>
                }
                @if (lname.hasError('containsSpecialChars')) {
                  <mat-error i18n>Special characters are not allowed in First Name.</mat-error>
                }
                @if (lname.hasError('textOnly')) {
                  <mat-error i18n>Text must have no extra spaces and only letters.</mat-error>
                }
                @if (lname.hasError('maxlength')) {
                  <mat-error i18n>Last name cannot be longer than 256 characters </mat-error>
                }
              </div>
            </div>
            <app-input
              [formCntlName]="emailMat"
              [inputType]="emailInputType"
              [label]="emailLabel"
              [prefixInputIcon]="mailIcon"
              [placeholder]="emailPlaceholder"
              (keyup)="handleGetOrgName($event)"
            ></app-input>
            @if (emailMat.hasError('email') && !emailMat.hasError('required')) {
              <mat-error i18n>Enter a valid email.</mat-error>
            }
            @if (emailMat.hasError('required') && emailMat.touched) {
              <mat-error i18n>Email is required</mat-error>
            }
            <app-input
              [formCntlName]="phone"
              [inputType]="textInputType"
              [label]="phnLabel"
              (keyup)="handleChange()"
              [placeholder]="phnPlaceholder"
              [inputStyle]="phnStyle"
              [prefixInputIcon]="phoneIcon"
            ></app-input>
            @if (phone.hasError('required') && phone.touched) {
              <mat-error i18n>Phone number is required</mat-error>
            }
            @if (phone.hasError('pattern')) {
              <mat-error i18n>Phone number entered is not in proper format.</mat-error>
            }
            <app-input
              class="last-field"
              [formCntlName]="orgName"
              [inputType]="textInputType"
              [label]="orgnameLabel"
              [prefixInputIcon]="accountCircleIcon"
              [placeholder]="orgNamePlaceholder"
              (keyup)="handleChange()"
            ></app-input>
            <mat-error i18n *ngIf="orgError" style="margin-top: 0" class="error">
              Organization name not found.
            </mat-error>
            <div class="footer-form-tnc">
              <p i18n>
                By signing in, you agree to our
                <a href="assets/pdf/nabsys_terms_and_conditions.pdf" target="_blank">Terms & Conditions</a> and
                <a href="assets/pdf/nabsys_privacy_policy.pdf" target="_blank">Privacy Policy</a>.
              </p>
              <app-button
                class="flow-cta"
                [fullWidth]="true"
                [disabled]="!(firstForm.valid && !orgError)"
                (click)="stepper.next()"
              >
                <span i18n>Next</span>
              </app-button>
              <p class="already-account" i18n>Already have an account? <a href="/login">Login</a></p>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="secondForm">
          <form [formGroup]="secondForm">
            <div class="header-form">
              <p>
                <button matStepperPrevious class="back-button" i18n>
                  <app-icons
                    [ariaHidden]="ariaHidden"
                    [ariaLabel]="ariaLabel"
                    [icon]="icon"
                    class="back-chevron"
                  ></app-icons>
                  {{ backLabel }}
                </button>
              </p>
              <div class="steps">
                <p i18n>Step 2 of 3</p>
                <span i18n>Signup</span>
              </div>
            </div>
            <div class="heading">
              <h6 i18n>Create New Password</h6>
              <p i18n>Enter the new password for your account.</p>
            </div>
            <app-input
              [formCntlName]="newPswd"
              [inputType]="newPasswordVisibility ? textInputType : passwordInputType"
              [label]="passwordLabel_new"
              [prefixInputIcon]="lockIcon"
              [suffixInputIcon]="newPasswordVisibility ? visibilityIcon : visibilityOffIcon"
              [maxLength]="32"
              (keyup)="handleChange()"
              (inputIconClickEvent)="handleNewPswdVisibilityCallback($event)"
            ></app-input>
            @if (newPswd.hasError('required') && newPswd.touched) {
              <mat-error i18n>This field is required</mat-error>
            }
            <app-input
              [formCntlName]="confirmPswd"
              [inputType]="confirmPasswordVisibilty ? textInputType : passwordInputType"
              [label]="passwordLabel_confirm"
              [prefixInputIcon]="lockIcon"
              [suffixInputIcon]="confirmPasswordVisibilty ? visibilityIcon : visibilityOffIcon"
              [maxLength]="32"
              (keyup)="handleChange()"
              (inputIconClickEvent)="handleConfirmPswdVisibilityCallback($event)"
            ></app-input>
            @if (confirmPswd.hasError('required') && confirmPswd.touched) {
              <mat-error i18n>This field is required</mat-error>
            } @else if ((confirmPswd.value ?? '').length > 0 && newPswd.value !== confirmPswd.value) {
              <mat-error i18n>Passwords do not match.</mat-error>
            }
            <div class="conditions">
              <span
                i18n
                class="password-rule checkbox-password-validator"
                [ngClass]="{
                  valid: (newPswd.value ?? '').length >= 8 && (newPswd.value ?? '').length <= 32,
                }"
              >
                <p>
                  <input
                    type="checkbox"
                    name="fr1"
                    [checked]="(newPswd.value ?? '').length >= 8 && (newPswd.value ?? '').length <= 32"
                    disabled
                  />
                </p>
                <p>{{ criteria1 }}</p>
              </span>
              <span
                i18n
                class="password-rule checkbox-password-validator"
                [ngClass]="{ valid: hasUpperCase(newPswd.value ?? '') }"
              >
                <p><input type="checkbox" name="fr2" [checked]="hasUpperCase(newPswd.value ?? '')" disabled /></p>
                <p>{{ criteria2 }}</p>
              </span>
              <span
                i18n
                class="password-rule checkbox-password-validator"
                [ngClass]="{ valid: hasNumber(newPswd.value ?? '') }"
              >
                <p><input type="checkbox" name="fr3" [checked]="hasNumber(newPswd.value ?? '')" disabled /></p>
                <p>{{ criteria3 }}</p>
              </span>
              <span
                i18n
                class="password-rule checkbox-password-validator"
                [ngClass]="{ valid: hasSplChar(newPswd.value ?? '') }"
              >
                <p><input type="checkbox" name="fr4" [checked]="hasSplChar(newPswd.value ?? '')" disabled /></p>
                <p>{{ criteria4 }}</p>
              </span>
            </div>

            <div class="footer-form-password">
              <app-button
                class="flow-cta"
                [fullWidth]="true"
                [disabled]="!isSecondFormValid"
                (click)="fetchOtp(); stepper.next()"
              >
                <span i18n>Continue</span>
              </app-button>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="thirdForm">
          <form [formGroup]="thirdForm" class="check-mail">
            <div class="header-form">
              <div>
                <button matStepperPrevious class="back-button" i18n>
                  <app-icons
                    [ariaHidden]="ariaHidden"
                    [ariaLabel]="ariaLabel"
                    [icon]="icon"
                    class="back-chevron"
                  ></app-icons>
                  <div class="check-mail-back-label">{{ backLabel }}</div>
                </button>
              </div>
              <div class="steps">
                <p i18n>Step 3 of 3</p>
                <span i18n>Signup</span>
              </div>
            </div>
            <div class="heading-third-form heading">
              <h6 i18n>Check your Mail</h6>
              <p i18n>
                We have sent a 6-digit code to
                <span style="color: #318f9a">{{ emailMat.value }}</span
                >. Make sure you enter the correct code.
              </p>
            </div>
            <div class="otp">
              <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{ length: 6 }"></ng-otp-input>
            </div>
            <mat-error i18n style="margin-top: 1em" *ngIf="otpError" class="error"> Wrong code. Try again </mat-error>
            <div class="footer-form-password">
              <app-button
                class="flow-cta"
                [fullWidth]="true"
                [disabled]="submitDisabled"
                (click)="handleSubmitForm($event)"
              >
                {{ buttonthree }}
              </app-button>
              <p i18n>
                Didn't receive code?
                <a class="resend" (click)="resendOtp()">{{ resendCode }}</a>
              </p>
            </div>
          </form>
        </mat-step>
      </mat-stepper>
    </div>
  </div>
</div>
